// Base MAINNET addresses (env-aware) — source of truth: ../addresses.json under key "8453"
// Keeps legacy exports so older imports continue working.

import RAW from '../addresses.json';

// Force Base mainnet
export const CHAIN_ID = 8453;
export const CHAIN_ID_HEX = '0x2105'; // Base mainnet hex
export const CHAIN_NAME = 'Base';

// Helper: env override with fallback
const env = (key, fallback) => {
  try {
    return (typeof process !== 'undefined' && process.env && process.env[key]) || fallback;
  } catch {
    return fallback;
  }
};

// Pull the 8453 map from addresses.json (string or number key)
const MAP = (RAW && (RAW[String(CHAIN_ID)] || RAW[CHAIN_ID])) || {};

export const CONTRACT_ADDRESSES = {
  ChainPlayToken:     env('REACT_APP_CPT_ADDRESS',       MAP.ChainPlayToken),
  ChainPlayTreasury:  env('REACT_APP_TREASURY_ADDRESS',  MAP.ChainPlayTreasury),
  ChainPlayBoostNFT:  env('REACT_APP_BOOST_NFT_ADDRESS', MAP.ChainPlayBoostNFT),
  ChainPlayStaking:   env('REACT_APP_STAKING_ADDRESS',   MAP.ChainPlayStaking),
  ChainPlayGame:      env('REACT_APP_GAME_ADDRESS',      MAP.ChainPlayGame),
  ChainPlayHoneyPot:  env('REACT_APP_HONEYPOT_ADDRESS',  MAP.ChainPlayHoneyPot),
  ChainPlayDAO:       env('REACT_APP_GOVERNOR_ADDRESS',  MAP.ChainPlayDAO),
  TimelockController: env('REACT_APP_TIMELOCK_ADDRESS',  MAP.TimelockController),
  BossFightPot:       env('REACT_APP_BOSSFIGHT_POT_ADDRESS', MAP.BossFightPot),
  TicketSnipeVRF:     env('REACT_APP_TICKET_SNIPE_VRF_ADDRESS', MAP.TicketSnipeVRF),
};

// Dev-time visibility if something is missing
if (typeof process !== 'undefined' && process?.env?.NODE_ENV !== 'production') {
  for (const [k, v] of Object.entries(CONTRACT_ADDRESSES)) {
    if (!v) console.warn(`[addresses] Missing ${k} for chain ${CHAIN_ID}`);
  }
}

export default CONTRACT_ADDRESSES;
